var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "row mt-5" },
    _vm._l(_vm.buttons, function (button) {
      return button.visible
        ? _c("div", { staticClass: "col" }, [
            _c(
              "button",
              {
                staticClass:
                  "btn btn-block btn-lg btn-outline-primary text-center p-5",
                on: {
                  click: function ($event) {
                    return _vm.fire(button.action, button.nextstep)
                  },
                },
              },
              [
                button.action == "back"
                  ? _c("i", { staticClass: "fa-2x fa fa-chevron-left" })
                  : _vm._e(),
                _vm._v(" "),
                button.action == "wrong"
                  ? _c("i", { staticClass: "fa-2x fa fa-times" })
                  : _vm._e(),
                _vm._v(" "),
                button.action == "next" || button.action == "finish"
                  ? _c("i", { staticClass: "fa-2x fa fa-check" })
                  : _vm._e(),
                _vm._v(" "),
                _c("br"),
                _vm._v("\n    " + _vm._s(button.label) + "\n"),
              ]
            ),
          ])
        : _vm._e()
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }